import React from 'react'
import { Link } from 'app/common/link'
import styled from 'styled-components'
import { style } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { Placeholder } from 'app/common/placeholder'
import { useIntl } from 'react-intl'
import type { MarketingAnimationShortDTO } from 'shared/types'
import { IMAGE_SIZE, resizeTwicpicsImage } from '../common/utils'

const { meltyYellow, white, bbqBrown } = colors

type MarketingAnimationKingdomProps = {
    kingdom?: MarketingAnimationShortDTO,
    mobile: boolean
}

export const MarketingAnimationKingdom = ({
    kingdom,
    mobile
}: MarketingAnimationKingdomProps) => {
    const intl = useIntl()
    const shouldDisplayKingdom =
        kingdom?.imageUrlPortrait && kingdom?.imageUrlPortrait
    if (!shouldDisplayKingdom) return null
    return (
        <Placeholder
            style={{
                display: 'flex',
                alignItems: 'end',
                justifyContent: 'center',
                padding: '20px'
            }}
            bgImg={resizeTwicpicsImage(
                mobile
                    ? kingdom?.imageUrlPortrait[0]
                    : kingdom?.imageUrlLandscape[0],
                IMAGE_SIZE.LARGE
            )}
            minHeightMobile="200vw"
            minHeightDesktop="27vw">
            {kingdom?.actionUrl && (
                <div>
                    <StyledButtonMedium
                        color={kingdom?.actionColor ? bbqBrown : white}
                        background={kingdom?.actionColor ?? meltyYellow}
                        url={kingdom?.actionUrl}>
                        {kingdom?.actionLabel}
                    </StyledButtonMedium>
                </div>
            )}
        </Placeholder>
    )
}

const StyledButtonMedium = styled(Link)`
    ${style.buttonMedium};
    border: none;
    max-width: 150px;
    margin: auto;
    background: ${props => props.background ?? 'none'};
    &.right {
        max-width: 200px;
    }
`
